import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type UpdateDeviceApiResponse } from '../services/updateDeviceService'

export interface UpdateDeviceState {
  isLoading: boolean
  error: string | undefined
  data: UpdateDeviceApiResponse | undefined
  httpStatus: number | undefined
}

export const initialState: UpdateDeviceState = {
  isLoading: false,
  error: undefined,
  data: undefined,
  httpStatus: 0
}

const updateDeviceSlice = createSlice({
  name: 'UpdateDeviceSlice',
  initialState,
  reducers: {
    updateDeviceLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: undefined,
        httpStatus: 0
      }
    },
    updateDeviceUpdateAction: (state, action: PayloadAction<{ data: UpdateDeviceApiResponse, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    updateDeviceErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: undefined,
        httpStatus: action.payload.httpStatus
      }
    },
    reset: () => initialState
  }
})

export const {
  updateDeviceLoadingAction,
  updateDeviceUpdateAction,
  updateDeviceErrorAction,
  reset
} = updateDeviceSlice.actions

export default updateDeviceSlice.reducer
